module.exports = __webpack_public_path__ + "img/6.9f0b3214.jpg";